import * as React from 'react'
import styled from 'styled-components'
import ContainerProps from 'src/components/containers/Resources'
import CollapseButton from 'src/components/atoms/input/buttons/Collapse'
import { media } from '../../../utils'

interface Props extends ContainerProps {
  title?: string
  footerComponent?: any
  collapsable?: boolean
  defaultCollapsed?: boolean
  style?: any
  hideOnMobile?: boolean
  showOverflow?: boolean
  actionIcon?: string
  idLabel?: any
  actionIconOnClick?: () => void
}

interface State {
  collapsed: boolean
}

export class ConfiguratorBox extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    const { defaultCollapsed } = this.props
    this.state = { collapsed: defaultCollapsed }
  }

  render() {
    const {
      title,
      children,
      footerComponent,
      collapsable,
      style,
      showOverflow,
      defaultCollapsed,
      actionIcon,
      actionIconOnClick,
      hideOnMobile,
      idLabel
    } = this.props
    const { collapsed } = this.state
    return (
      <Container hideOnMobile={hideOnMobile} style={style}>
        {title && (
          <Header>
            <VerticalAlignWrapper>
              <h2>{title}</h2>
              {actionIcon && (
                <ActionIcon  onClick={actionIconOnClick}>
                  <i className={`fas ${actionIcon}`} />
                </ActionIcon>
              )}
              {collapsable && (
                <CollapseButton
                  defaultCollapsed={defaultCollapsed}
                  idLabel={idLabel}
                  onClick={(c) => this.setState({ collapsed: c })}
                />
              )}
            </VerticalAlignWrapper>
          </Header>
        )}
        <Content
          collapsed={collapsed}
          showOverflow={showOverflow && !collapsed}>
          {children}
        </Content>
        {footerComponent}
      </Container>
    )
  }
}

const ActionIcon = styled.div`
  margin-left: auto;
  color: #984354;
  padding-left: 7.5%;
  font-size: 20px;
  cursor: pointer;
`

const Container = styled.div`
  margin-bottom: 30px;
  background-color: white;
  box-shadow: inset 0 -1px 0 0 #f4f4f4, 0 8px 16px 0 rgba(0, 0, 0, 0.1);
  ${(props) => {
    if (props.hideOnMobile) return media.giant`display: none;`
  }}
`

const Header = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: inherit;
  margin: 0px;
  width: 100%;
  padding: 15px;
  background-color: #a7c9cd;
  letter-spacing: 1.25px;

  h2 {
    font-size: inherit;
    font-weight: inherit;
    padding: inherit;
    margin: inherit;
    ${media.desktop`font-size: 18px;`}
    ${media.phone`font-size: 16px;`}
  }
`

const Content = styled.div`
  height: auto;
  padding: 15px;
  background-color: white;
  overflow: ${(props) => (props.showOverflow ? 'visible' : 'hidden')};

  h2 {
    width: 100%;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 1.25px;
    ${media.desktop`font-size: 18px;`}
    ${media.phone`font-size: 16px; letter-spacing: 1px;`}
  }

  ${(props) =>
    props.collapsed &&
    `
    padding: 0;
    height: 0;
  `}
`

export const VerticalAlignWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin: ${(props) => {
    if (!props.margin) return '0px'
    if (Number.isInteger(props.margin)) return `${props.margin}px`
    return props.margin
  }};
  ${(props) => props.column && 'flex-direction: column;'}
  ${(props) =>
    props.horizontalAlignment
      ? `justify-content: ${props.horizontalAlignment};`
      : ''}
  ${(props) => (props.clickable ? 'cursor: pointer;' : '')}
  ${(props) => (props.color ? `color: ${props.color};` : '')}
`

export const HighlightInBox = styled.div`
  margin: 15px 0;
  padding: 15px;
  background: #d5e4e6;
`



// WEBPACK FOOTER //
// ./src/components/containers/configurator/ConfiguratorBox.tsx